export const ONBOARDING = 'onboarding';
export const INVITE_FRIENDS = 'invite_friends';
export const SUGGESTED_FRIENDS = 'suggested_friends';

export default { ONBOARDING, INVITE_FRIENDS, SUGGESTED_FRIENDS };
